import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEffectiveTaskRatesForProjectChargeQueryVariables = Types.Exact<{
  asOf: Types.Scalars['LocalDate'];
  projectNumber: Types.Scalars['Int'];
}>;


export type GetEffectiveTaskRatesForProjectChargeQuery = { __typename?: 'QueryModel', projects?: { __typename?: 'ProjectsQueryModelOld', effectiveTaskRateSheet?: { __typename?: 'TaskRateSheet', name: string, rates?: Array<{ __typename?: 'TaskRate', name: string, billableAmount?: number | null, unit: Types.TaskRateUnit, usesEmployeeRate: boolean, glAccount?: string | null } | null> | null } | null } | null };


export const GetEffectiveTaskRatesForProjectChargeDocument = gql`
    query GetEffectiveTaskRatesForProjectCharge($asOf: LocalDate!, $projectNumber: Int!) {
  projects {
    effectiveTaskRateSheet(asOf: $asOf, projectNumber: $projectNumber) {
      name
      rates {
        name
        billableAmount
        unit
        usesEmployeeRate
        glAccount
      }
    }
  }
}
    `;

/**
 * __useGetEffectiveTaskRatesForProjectChargeQuery__
 *
 * To run a query within a React component, call `useGetEffectiveTaskRatesForProjectChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEffectiveTaskRatesForProjectChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEffectiveTaskRatesForProjectChargeQuery({
 *   variables: {
 *      asOf: // value for 'asOf'
 *      projectNumber: // value for 'projectNumber'
 *   },
 * });
 */
export function useGetEffectiveTaskRatesForProjectChargeQuery(baseOptions: Apollo.QueryHookOptions<GetEffectiveTaskRatesForProjectChargeQuery, GetEffectiveTaskRatesForProjectChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEffectiveTaskRatesForProjectChargeQuery, GetEffectiveTaskRatesForProjectChargeQueryVariables>(GetEffectiveTaskRatesForProjectChargeDocument, options);
      }
export function useGetEffectiveTaskRatesForProjectChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEffectiveTaskRatesForProjectChargeQuery, GetEffectiveTaskRatesForProjectChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEffectiveTaskRatesForProjectChargeQuery, GetEffectiveTaskRatesForProjectChargeQueryVariables>(GetEffectiveTaskRatesForProjectChargeDocument, options);
        }
export type GetEffectiveTaskRatesForProjectChargeQueryHookResult = ReturnType<typeof useGetEffectiveTaskRatesForProjectChargeQuery>;
export type GetEffectiveTaskRatesForProjectChargeLazyQueryHookResult = ReturnType<typeof useGetEffectiveTaskRatesForProjectChargeLazyQuery>;
export type GetEffectiveTaskRatesForProjectChargeQueryResult = Apollo.QueryResult<GetEffectiveTaskRatesForProjectChargeQuery, GetEffectiveTaskRatesForProjectChargeQueryVariables>;